module.exports = __webpack_public_path__ + "img/Tuvalu.daf923e6.png";